export const METERS_IN_KILOMETER = 1000;
export const CENTIMETERS_IN_METER = 100;
export const MILLIMETERS_IN_METER = 1000;
export const METERS_IN_FOOT = 0.3048;
export const METERS_IN_NAUTICAL_MILE = 1852;
export const KILOMETERS_IN_NAUTICAL_MILE = 1.852;
